import React from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import { HelpPage } from './HelpPage';
import HomePage from './HomePage';
import NoMatch from './NoMatch';
import { OnBoard } from "./Onboard"
import HelpRedirect from './HelpRedirect';
import OnBoardRedirect from './OnBoardRedirect';
import AppInstall from './AppInstall';
import { LanguageEnum, isLanguageValid } from './helpers/LanguageHelper';
import { CountryConfig, setDefaultLang } from './interfaces/Config';
import { CountryEnum, isCountryValid } from './helpers/CountryHelper';
import LegacyRedirect from './LegacyRedirect';
import { SelfReset } from './SelfReset';
import CountryGrid from './CountryGrid';
import PageSelector from './PageSelector';
import LanguageSelector from './LanguageSelector';
import { DeleteMFADevicesPage } from './DeleteMFADevicesPage';


function App() {
  const rawCountriesData = JSON.parse(process.env.REACT_APP_COUNTRIES || '[]');
  const countries: CountryConfig[] = setDefaultLang(rawCountriesData);

  return (
    <div>
      <Routes>
        <Route key="home" path="/" element={<PageSelector countries={countries} />} />
        {countries.map(c => {
          if (!isCountryValid(c.Country) || !isLanguageValid(c.AvailableLangs)) {
            console.error("Invalid Language");
            return <></>;
          }
          else return (<>
            <Route key="onboardLegacy" path={`onboard/${c.Country}`} element={<LegacyRedirect country={c.Country} lang={c.DefaultLang} />} />
            <Route key={c.Country} path={`/${c.Country}`}>
              <Route index element={<HomePage lang={c.DefaultLang} />} />
              <Route path="help" element={<HelpRedirect lang={c.DefaultLang} />} />
              <Route path="onboard" element={<LanguageSelector country={c as CountryConfig} />} />
              <Route path="selfReset" element={<LanguageSelector country={c as CountryConfig} />} />
              <Route path={`appinstall`} element={<AppInstall country={c.Country as CountryEnum} />} />
              <Route path="deleteMFADevices" element={<DeleteMFADevicesPage lang = {c.DefaultLang} />} />
              {c.AvailableLangs.map(lang => (
                <React.Fragment key={`${c.Country}-${lang}`}>
                  <Route path={`help/${lang}`} element={<HelpPage country={c.Country as CountryEnum} lang={lang as LanguageEnum} />} />
                  <Route path={`onboard/${lang}`} element={<OnBoard country={c.Country as CountryEnum} lang={lang as LanguageEnum} />} />
                  {c.SelfReset && <Route path={`selfReset/${lang}`} element={<SelfReset country={c.Country as CountryEnum} lang={lang as LanguageEnum} />} />}
                </React.Fragment>
              ))}
              {/* Using path="*"" means "match anything", so this route acts like a catch-all for URLs that we don't have explicit routes for. */}
            </Route>
          </>)
        })}
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </div>
  );
}

function updateTitle(pathname: string) {
  let title = "CNH User Activation";
  switch (pathname) {
    default:
      if (pathname.indexOf("onboard") !== -1) {
        title = "CNH User Activation";
      } else if (pathname.indexOf("/selfReset") !== -1) {
        title = "CNH Reset Password";
      }
      break;
  }
  document.title = title;
}

export default App;
